import { atom } from 'jotai'

import type { AnswerableProgress } from '@renderer/chat/integrations/answerable'

/** Locally-recorded partial answers per pending answerable action (question or feedback). */
export const optimisticQuestionAnswersAtom = atom<Record<string, AnswerableProgress>>({})
